"use client";
import Hero from "@/components/Hero";
import About from "@/components/About";
import Projects from "@/components/Projects";
import Contact from "@/components/Contact";

export default function HomePage() {
  return (
    <div className="w-full">
      <Hero />
      <About />
      <Projects />
      <Contact />
    </div>
  );
}
